import React from 'react'

export default (props) => {
  return (
    <div className='loader app__loader'>
      <div className='loader__spinner'>
        <div className='spinner' />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Layout/Loader/Loader.jsx